import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import ReactDOM from 'react-dom';
import mapboxgl from 'mapbox-gl';
import { map } from './Map';
import StartsStopsView from "./StartsStopsView";
import {useSelector} from "react-redux";
import {createAppTheme} from "../theme";
import {ThemeProvider} from "@material-ui/core/styles";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";

const StartsStops = React.memo( ({ positions, stops }) => {


    const onMouseEnter = (e) => {e.target.style.cursor = 'pointer';};
    const onMouseLeave = (e) => {e.target.style.cursor = '';};
    const [popup, setPopup] = useState({targetEff: false, pos: null, status: null, deviceName: null});
    const markerRef = useRef([]);
    const markerRef1 = useRef([]);
    const devices = useSelector(state => state.devices.items);
    const mode = useSelector(state => state.theme.mode)
    const theme = useMemo(() => createAppTheme(mode), [mode])


    const getDeviceName = useCallback((deviceId) => devices[deviceId]?.name, [devices]);

    useEffect(() => {
        const startStopPositions = [positions[0], positions[positions.length-1]];
        if (!startStopPositions || startStopPositions.length === 0) return;

        if (markerRef.current) {
            markerRef.current.forEach(mrk => mrk.marker.remove())
        }
        markerRef.current = []
        startStopPositions.forEach((position, index) => {
            const { longitude, latitude } = position;
            const markerElement = document.createElement('div');
            const iconSource = index === 0 ? 'images/start.png' : 'images/end.png';
            ReactDOM.render(
                <img
                    src={iconSource}
                    alt={index === 0 ? "Start" : "End"}
                    style={{ width: '25px' }}
                />,
                markerElement
            );
            const marker = new mapboxgl.Marker(markerElement)
                .setLngLat([longitude, latitude])
                .addTo(map);

            const status = position.id === positions[0].id ? "Start" : "End";
            markerElement.addEventListener("mouseenter", onMouseEnter);
            markerElement.addEventListener('mouseleave', onMouseLeave);
            markerElement.addEventListener('click', () =>
                setPopup({targetEff: true, pos: position, status: status, deviceName: getDeviceName(position.deviceId)}));

            markerRef.current.push({ marker });
        });
        return () => {
            if (markerRef.current) {
                markerRef.current.forEach(mrk => mrk.marker.remove()); // Remove markers on cleanup
            }
            markerRef.current = []; // Reset markerRef array on component unmount
        };
    }, [positions]);

    useEffect(() => {
        if (!stops || stops.length === 0) return;

        if (markerRef1.current) {
            markerRef1.current.forEach(mrk => mrk.marker.remove())
        }
        markerRef1.current = []
        stops.forEach(stop => {
            const { longitude, latitude } = stop;

            const markerElement = document.createElement('div');
            const iconSource = stop.duration < 120000 ? 'images/parkingOrg.png' : 'images/parkingRed.png';
            ReactDOM.render(
                <img
                    src={iconSource}
                    alt="parking"
                    style={{ width: '20px' }}
                />,
                markerElement
            );
            const marker = new mapboxgl.Marker(markerElement)
                .setLngLat([longitude, latitude])
                .addTo(map);

            markerElement.addEventListener("mouseenter", onMouseEnter);
            markerElement.addEventListener('mouseleave', onMouseLeave);
            markerElement.addEventListener('click', () => setPopup({targetEff: true, pos: stop}));

            markerRef1.current.push({ marker });
        });
        return () => {
            if (markerRef1.current) {
                markerRef1.current.forEach(mrk => mrk.marker.remove()); // Remove markers on cleanup
            }
            markerRef1.current = []; // Reset markerRef array on component unmount
        };
    }, [stops]);

    useEffect(() => {
        if(popup.pos){
            const placeHolder = document.createElement('div');
            ReactDOM.render(
                <ThemeProvider theme={theme}>
                    <StartsStopsView position={popup.pos} status={popup.status} deviceName={popup.deviceName}/>
                </ThemeProvider>
                , placeHolder);
            new mapboxgl.Popup({
                offset: 30,
                anchor: 'bottom'
            }).setDOMContent(placeHolder).setLngLat([popup.pos.longitude, popup.pos.latitude]).addTo(map);
        }
    }, [popup, mode]);

    useEffect(() => {
        const styleId = 'mapbox-cyber-popup';
        let styleElement = document.getElementById(styleId);

        if (!styleElement) {
            styleElement = document.createElement('style');
            styleElement.id = styleId;
            document.head.appendChild(styleElement);
        }

        const isDarkMode = theme.palette.typeBackground === 'dark';

        const popupBg = isDarkMode
            ? 'rgba(15, 25, 35, 0.7)'
            : 'rgba(255, 255, 255, 0.5)';

        const glowOpacity = isDarkMode ? '0.4' : '0.2';

        styleElement.innerHTML = `
      .mapboxgl-popup-content {
        background: ${popupBg} !important;
        backdrop-filter: blur(10px) !important;
        -webkit-backdrop-filter: blur(10px) !important;
        border: 1px solid #00f2ff !important;
        box-shadow: 0 0 20px rgba(0, 242, 255, ${glowOpacity}) !important;
        border-radius: 12px !important;
        padding: 0 !important;
      }
      .mapboxgl-popup-tip {
        border-top-color: #00f2ff !important;
        border-bottom-color: #00f2ff !important;
        opacity: 0.6;
      }
      .mapboxgl-popup-close-button {
        color: #00f2ff !important;
        font-size: 16px !important;
        padding: 5px 8px !important;
        outline: none !important;
      }
      .mapboxgl-popup-close-button:hover {
        background-color: rgba(0, 242, 255, 0.1) !important;
        border-radius: 0 12px 0 0;
      }
    `;

        // Clean up style on unmount if necessary
        return () => {
            // If you want the style to disappear when the component unmounts:
            // if (styleElement) styleElement.remove();
        };
    }, [theme]);

    return null;
});

export default StartsStops;

